import { Injectable } from '@angular/core';
import { WorkflowTaskModel } from '../../api/model/common/workflowTask.model';
import { WorkflowTaskRepository } from './ngrx/workflowTask.repository';
import { WorkflowTaskDataServiceAdapter } from './ngrx/workflowTaskDataService.adapter';
import { AbstractFindOneByIdService } from '../../../../core/service/v2/service/findone/abstractFindOneById.service';

@Injectable()
export class WorkflowTaskFindOneByIdService extends AbstractFindOneByIdService<WorkflowTaskModel, WorkflowTaskModel> {

    constructor(repository: WorkflowTaskRepository, dataServiceAdapter: WorkflowTaskDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
